'use client'
import { GetAccountBalancesNetworkIdEnum } from '@dynamic-labs/sdk-api-core';

const MULTI_ASSET_SUPPORTED_NETWORKS = Object.values(GetAccountBalancesNetworkIdEnum);

export { MULTI_ASSET_SUPPORTED_NETWORKS };
